import { LOCALE } from '../../../constants/activity-constants'
import a1 from './a1'
import a2 from './a2'

import pe_a1 from './locale/pe/a1'
import pe_a2 from './locale/pe/a2'

import cl_a1 from './locale/cl/a1'
import cl_a2 from './locale/cl/a2'

import ar_a1 from './locale/ar/a1'
import ar_a2 from './locale/ar/a2'

import ec_a1 from './locale/ec/a1'
import ec_a2 from './locale/ec/a2'

const getAnimationByLocale = () => {
  if (LOCALE === 'es-PE') {
    return { 1: pe_a1, 2: pe_a2 }
  }
  if (LOCALE === 'es-CL') {
    return { 1: cl_a1, 2: cl_a2 }
  }
  if (LOCALE === 'es-AR') {
    return { 1: ar_a1, 2: ar_a2 }
  }
  if (LOCALE === 'es-EC') {
    return { 1: ec_a1, 2: ec_a2 }
  }
  return {
    1: a1,
    2: a2,
  }
}
// DEFAULT STRUCTURE
const lottieJsonAnimation = getAnimationByLocale()

export default lottieJsonAnimation
